import styled from '@emotion/styled';
import { Flex } from '@linearb/linui-common';
import SlashLines from './backgroundElements/SlashLines.style';

const LoginBackgroundContainer = styled(Flex)`
  height: 100vh;
  ${SlashLines} {
    margin-right: 14rem;
  }
`;

export default LoginBackgroundContainer;
